// ============================================
// COSMIC HINDU - Site Constants
// ============================================

export const SITE = {
  name:        'Cosmic Hindu',
  tagline:     'Divine • Sacred • Eternal',
  domain:      'cosmichindu.com',
  url:         'https://cosmichindu.com',
  email:       'namaste@cosmichindu.com',
  phone:       '+91 98765 43210',
  address:     '123 Temple Street, Mylapore, Chennai, Tamil Nadu 600004',
  hours:       'Mon-Sat: 9AM - 8PM IST',
  currency:    'INR',
  currencySymbol: '₹',
  // CartContext uses these directly from SITE
  freeShippingThreshold: 999,
  shippingCost:          99,
  codCharge:             49,
};

export const SHIPPING = {
  freeThreshold: 999,
  standardRate:  99,
  codCharge:     49,
  estimatedDays: '3-7 business days',
};

export const PAYMENT_METHODS = {
  upi:  { id: 'upi',  label: 'UPI Payment',       icon: '📱' },
  card: { id: 'card', label: 'Card Payment',       icon: '💳' },
  cod:  { id: 'cod',  label: 'Cash on Delivery',   icon: '💰' },
};

export const UPI_APPS = ['Google Pay', 'PhonePe', 'Paytm', 'BHIM'];
export const CARD_NETWORKS = ['VISA', 'MasterCard', 'RuPay', 'Amex'];

// color = text class, bg = background class (Tailwind)
export const ORDER_STATUSES = {
  pending:   { label: 'Pending',   icon: '⏳', color: 'text-yellow-400',  bg: 'bg-yellow-400/10'  },
  confirmed: { label: 'Confirmed', icon: '✅', color: 'text-blue-400',    bg: 'bg-blue-400/10'    },
  blessed:   { label: 'Blessed',   icon: '🙏', color: 'text-violet-400',  bg: 'bg-violet-400/10'  },
  shipped:   { label: 'Shipped',   icon: '🚚', color: 'text-orange-400',  bg: 'bg-orange-400/10'  },
  delivered: { label: 'Delivered', icon: '✓',  color: 'text-emerald-400', bg: 'bg-emerald-400/10' },
  cancelled: { label: 'Cancelled', icon: '✕',  color: 'text-red-400',     bg: 'bg-red-400/10'     },
  returned:  { label: 'Returned',  icon: '↩',  color: 'text-gray-400',    bg: 'bg-gray-400/10'    },
};

export const ADMIN_NAV = [
  { path: '/admin',             label: 'Dashboard',   icon: 'LayoutDashboard' },
  { path: '/admin/orders',      label: 'Orders',      icon: 'ShoppingBag' },
  { path: '/admin/products',    label: 'Products',    icon: 'Package' },
  { path: '/admin/discounts',   label: 'Discounts',   icon: 'Tag' },
  { path: '/admin/customers',   label: 'Customers',   icon: 'Users' },
  { path: '/admin/analytics',   label: 'Analytics',   icon: 'BarChart3' },
  { path: '/admin/settings',    label: 'Settings',    icon: 'Settings' },
];

// ── Colour palette used throughout admin UI ──────────────────────────────────
export const COLORS = {
  templeDark:  '#0F0A05',
  gold:        '#D4A843',
  goldBright:  '#FFD700',
  saffron:     '#FF6B00',
  cream:       '#FFF8F0',
  maroon:      '#800020',
  templeRed:   '#C41E3A',   // used in Header badge & ProductCard wishlist icon
  borderGold:  'rgba(212,168,67,0.2)',
  textMuted:   'rgba(255,248,240,0.4)',
};

// ── Product categories ────────────────────────────────────────────────────────
export const CATEGORIES = [
  { id: 'idols',      name: 'God Idols',           icon: '🙏' },
  { id: 'rudraksha',  name: 'Rudraksha',            icon: '📿' },
  { id: 'karungali',  name: 'Karungali',            icon: '🪵' },
  { id: 'jewellery',  name: 'Spiritual Jewellery',  icon: '✨' },
  { id: 'japamala',   name: 'Japa Mala',            icon: '🔮' },
  { id: 'astrostone', name: 'Astro Stone',          icon: '💎' },
  { id: 'pooja',      name: 'Pooja Essentials',     icon: '🪔' },
];
